import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import './LeaveConfirmDialog.css';

/**
 * Leave Chat Confirmation Dialog
 * Displays confirmation dialog with proper styling based on internal/external chat type
 */
const LeaveConfirmDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title, 
  isInternal = false,
  confirmText = "Ok",
  cancelText = "Abbrechen"
}) => {
  const primaryColor = isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)';
  
  const buttonClassName = `leave-confirm-dialog__btn${isInternal ? ' leave-confirm-dialog__btn--internal' : ''}`;

  const handleMouseEnter = (e) => {
    const button = e.currentTarget;
    button.style.backgroundColor = primaryColor;
    button.style.color = '#fff';
    const label = button.querySelector('.MuiButton-label');
    if (label) label.style.color = '#fff';
  };

  const handleMouseLeave = (e) => {
    const button = e.currentTarget;
    button.style.backgroundColor = '#fff';
    button.style.color = primaryColor;
    const label = button.querySelector('.MuiButton-label');
    if (label) label.style.color = primaryColor;
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="leave-confirm-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle 
        id="leave-confirm-dialog-title"
        className="leave-confirm-dialog__title"
      >
        {title}
      </DialogTitle>
      <DialogActions className="leave-confirm-dialog__actions">
        <Button
          onClick={onClose}
          className={buttonClassName}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <span className="leave-confirm-dialog__label">{cancelText}</span>
        </Button>
        <Button
          onClick={onConfirm}
          className={buttonClassName}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <span className="leave-confirm-dialog__label">{confirmText}</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LeaveConfirmDialog;

